export default __webpack_public_path__ + "static/media/task-list-view-icon.39fb3e14.svg";